"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PopupGeneratorUpdateModes = exports.PopupGeneratedStatsImpressionTypes = exports.PopupGeneratorNavigatorInputTypes = exports.PopupCategories = void 0;
var PopupCategories;
(function (PopupCategories) {
    PopupCategories["SLIDE_IN"] = "slidein";
    PopupCategories["LIGHTBOX"] = "lightbox";
    PopupCategories["BIG_SIDE_BAR"] = "bigsidebar";
    PopupCategories["SUCCESS_PAGE"] = "successpage";
})(PopupCategories || (exports.PopupCategories = PopupCategories = {}));
var PopupGeneratorNavigatorInputTypes;
(function (PopupGeneratorNavigatorInputTypes) {
    PopupGeneratorNavigatorInputTypes["URL"] = "url";
    PopupGeneratorNavigatorInputTypes["TEXT"] = "text";
    PopupGeneratorNavigatorInputTypes["EMAIL"] = "email";
    PopupGeneratorNavigatorInputTypes["NUMBER"] = "number";
})(PopupGeneratorNavigatorInputTypes || (exports.PopupGeneratorNavigatorInputTypes = PopupGeneratorNavigatorInputTypes = {}));
var PopupGeneratedStatsImpressionTypes;
(function (PopupGeneratedStatsImpressionTypes) {
    PopupGeneratedStatsImpressionTypes["SHOWN"] = "shown";
    PopupGeneratedStatsImpressionTypes["CLOSED"] = "closed";
})(PopupGeneratedStatsImpressionTypes || (exports.PopupGeneratedStatsImpressionTypes = PopupGeneratedStatsImpressionTypes = {}));
var PopupGeneratorUpdateModes;
(function (PopupGeneratorUpdateModes) {
    PopupGeneratorUpdateModes["STATUS"] = "status";
    PopupGeneratorUpdateModes["QR_CODES"] = "qr-codes";
    PopupGeneratorUpdateModes["DESCRIPTION"] = "description";
})(PopupGeneratorUpdateModes || (exports.PopupGeneratorUpdateModes = PopupGeneratorUpdateModes = {}));
